import { useDispatch, useSelector } from 'react-redux'

import CheckoutButton from '@/components/UniversalLoginModal/CheckoutButton'
import { actions as flashActions } from '@/reducers/flashMessages'
import {
  canContinueCheckoutSelector
} from '@/selectors'
import { newRouteFor } from '@/utils/router'
import { translate } from '@/utils/translations'

const BUTTON_TEXT = translate('carts.send_purchase_order_request')
const BUTTON_CLASSES = [
  'btn',
  'vst-btn--transparent',
  'styled-as-link-ocean',
  'link--branded',
  'u-full-width'
].join(' ')

const PurchaseOrderRequestLink = () => {
  const canContinuePurchaseOrder = useSelector(canContinueCheckoutSelector)
  const isUniversalLoginEnabled = useSelector(
    state => !state.mobileMenu.isLoggedIn
  )
  const dispatch = useDispatch()

  const handleClick = () => {
    if (canContinuePurchaseOrder) {
      window.location.assign(newRouteFor('/purchase-order-request'))
    } else {
      handleError()
    }
  }

  const handleError = () => {
    dispatch(
      flashActions.setFlashMessages([{
        text: translate('errors.accept_terms_failure'),
        type: 'page_level_message_as_error'
      }])
    )
  }

  return (
    <Choose>
      <When condition={isUniversalLoginEnabled}>
        <CheckoutButton
          buttonText={BUTTON_TEXT}
          canSubmit={canContinuePurchaseOrder}
          className={BUTTON_CLASSES}
          handleError={handleError}
          url={
            `${window.location.origin}${newRouteFor('/purchase-order-request')}`
          }
        />
      </When>
      <Otherwise>
        <button
          className={BUTTON_CLASSES}
          data-testid='purchase-order-button'
          onClick={handleClick}
          role='link'
          type='button'
        >
          {translate('carts.send_purchase_order_request')}
        </button>
      </Otherwise>
    </Choose>
  )
}

export default PurchaseOrderRequestLink
